import script from "./TransferForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferForm.vue?vue&type=script&setup=true&lang=js"

import "./TransferForm.vue?vue&type=style&index=0&id=143d97c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143d97c4"]])

export default __exports__